export const createItem = /* GraphQL */ `
  mutation createItem($input: CreateItemInput!) {
  createItem(input: $input) {
      ackUpdatedBy
      acknowledgement
      acknowledgementRequired
      archived
      childIds
      createdAt
      creator
      deletedAt
      description
      id
      name
      ownerId
      parentIds
      pinned
      pinnedIds
      readRoles
      statusRestoreParentIds
      statusSourceLibraryId
      statusUpdatedBy
      trashed
      type
      updatedAt
      updatedBy
      version
      workspaceId
      writeRoles
  }
}
`;

export const createNotification = /* GraphQL */ `
  mutation createNotification($input: CreateNotificationInput!) {
  createNotification(input: $input) {
      channelAttempts
      createdAt
      deletedAt
      eventId
      id
      initiatorId
      meta
      ownerId
      status
      type
      updatedAt
      userId
  }
}
`;

export const createWorkspace = /* GraphQL */ `
  mutation createWorkspace($input: CreateWorkspaceInput!) {
  createWorkspace(input: $input) {
      archivedIds
      avatarPath
      childIds
      createdAt
      deletedAt
      id
      name
      ownerId
      pinnedIds
      slug
      trashedIds
      updatedAt
      version
  }
}
`;

export const createWorkspaceUser = /* GraphQL */ `
  mutation createWorkspaceUser($input: CreateWorkspaceUserInput!) {
  createWorkspaceUser(input: $input) {
      createdAt
      createdBy
      deletedAt
      id
      ownerId
      role
      updatedAt
      updatedBy
      userId
      version
      workspaceId
  }
}
`;

export const deleteItem = /* GraphQL */ `
  mutation deleteItem($input: DeleteItemInput!) {
  deleteItem(input: $input) {
      ackUpdatedBy
      acknowledgement
      acknowledgementRequired
      archived
      childIds
      createdAt
      creator
      deletedAt
      description
      id
      name
      ownerId
      parentIds
      pinned
      pinnedIds
      readRoles
      statusRestoreParentIds
      statusSourceLibraryId
      statusUpdatedBy
      trashed
      type
      updatedAt
      updatedBy
      version
      workspaceId
      writeRoles
  }
}
`;

export const deleteItemForever = /* GraphQL */ `
  mutation deleteItemForever($input: DeleteItemForeverInput!) {
  deleteItemForever(input: $input) {
      ackUpdatedBy
      acknowledgement
      acknowledgementRequired
      archived
      childIds
      createdAt
      creator
      deletedAt
      description
      id
      name
      ownerId
      parentIds
      pinned
      pinnedIds
      readRoles
      statusRestoreParentIds
      statusSourceLibraryId
      statusUpdatedBy
      trashed
      type
      updatedAt
      updatedBy
      version
      workspaceId
      writeRoles
  }
}
`;

export const deleteWorkspace = /* GraphQL */ `
  mutation deleteWorkspace($input: DeleteWorkspaceInput!) {
  deleteWorkspace(input: $input) {
      archivedIds
      avatarPath
      childIds
      createdAt
      deletedAt
      id
      name
      ownerId
      pinnedIds
      slug
      trashedIds
      updatedAt
      version
  }
}
`;

export const deleteWorkspaceUser = /* GraphQL */ `
  mutation deleteWorkspaceUser($input: DeleteWorkspaceUserInput!) {
  deleteWorkspaceUser(input: $input) {
      createdAt
      createdBy
      deletedAt
      id
      ownerId
      role
      updatedAt
      updatedBy
      userId
      version
      workspaceId
  }
}
`;

export const duplicateCluster = /* GraphQL */ `
  mutation duplicateCluster($input: DuplicateClusterInput!) {
  duplicateCluster(input: $input) {
      ackUpdatedBy
      acknowledgement
      acknowledgementRequired
      archived
      childIds
      createdAt
      creator
      deletedAt
      description
      id
      name
      ownerId
      parentIds
      pinned
      pinnedIds
      readRoles
      statusRestoreParentIds
      statusSourceLibraryId
      statusUpdatedBy
      trashed
      type
      updatedAt
      updatedBy
      version
      workspaceId
      writeRoles
  }
}
`;

export const registerPushSubscription = /* GraphQL */ `
  mutation registerPushSubscription($input: RegisterPushSubscriptionInput!) {
  registerPushSubscription(input: $input) {
      success
  }
}
`;

export const unregisterPushSubscription = /* GraphQL */ `
  mutation unregisterPushSubscription($input: UnregisterPushSubscriptionInput!) {
  unregisterPushSubscription(input: $input) {
      success
  }
}
`;

export const updateClient = /* GraphQL */ `
  mutation updateClient($input: UpdateClientInput!) {
  updateClient(input: $input) {
      ... on Client {
        createdAt
        created_at
        customer_id
        defaultWorkspaces
        deletedAt
        id
        inviteLink
        meta
        name
        ownerUserId
        slug
        subscription_details
        subscription_endsAt
        subscription_plan
        subscription_status
        updatedAt
        userRole
        version
      }
      ... on ConflictError {
        actualVersion
        conflictType
        currentState
        entityId
        entityType
        expectedVersion
        metadata
      }
  }
}
`;

export const updateClientUser = /* GraphQL */ `
  mutation updateClientUser($input: UpdateClientUserInput!) {
  updateClientUser(input: $input) {
      ... on ClientUser {
        avatarPath
        closedAt
        createdAt
        deletedAt
        email
        id
        isAdmin
        isConfirmed
        isReadOnly
        lastActive
        name
        ownerId
        roleUpdatedBy
        roles
        sub
        surname
        updatedAt
        version
      }
      ... on ConflictError {
        actualVersion
        conflictType
        currentState
        entityId
        entityType
        expectedVersion
        metadata
      }
  }
}
`;

export const updateItem = /* GraphQL */ `
  mutation updateItem($input: UpdateItemInput!) {
  updateItem(input: $input) {
      ... on ConflictError {
        actualVersion
        conflictType
        currentState
        entityId
        entityType
        expectedVersion
        metadata
      }
      ... on Item {
        ackUpdatedBy
        acknowledgement
        acknowledgementRequired
        archived
        childIds
        createdAt
        creator
        deletedAt
        description
        id
        name
        ownerId
        parentIds
        pinned
        pinnedIds
        readRoles
        statusRestoreParentIds
        statusSourceLibraryId
        statusUpdatedBy
        trashed
        type
        updatedAt
        updatedBy
        version
        workspaceId
        writeRoles
      }
  }
}
`;

export const updateNotification = /* GraphQL */ `
  mutation updateNotification($input: UpdateNotificationInput!) {
  updateNotification(input: $input) {
      channelAttempts
      createdAt
      deletedAt
      eventId
      id
      initiatorId
      meta
      ownerId
      status
      type
      updatedAt
      userId
  }
}
`;

export const updateWorkspace = /* GraphQL */ `
  mutation updateWorkspace($input: UpdateWorkspaceInput!) {
  updateWorkspace(input: $input) {
      ... on ConflictError {
        actualVersion
        conflictType
        currentState
        entityId
        entityType
        expectedVersion
        metadata
      }
      ... on Workspace {
        archivedIds
        avatarPath
        childIds
        createdAt
        deletedAt
        id
        name
        ownerId
        pinnedIds
        slug
        trashedIds
        updatedAt
        version
      }
  }
}
`;

export const updateWorkspaceUser = /* GraphQL */ `
  mutation updateWorkspaceUser($input: UpdateWorkspaceUserInput!) {
  updateWorkspaceUser(input: $input) {
      createdAt
      createdBy
      deletedAt
      id
      ownerId
      role
      updatedAt
      updatedBy
      userId
      version
      workspaceId
  }
}
`;
